 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLACKNOWLEDGEMENTS from '@/components/xhtml/acknowledgements'
 import XHTMLINTRODUCTION from '@/components/xhtml/introduction'
 import XHTMLPART001 from '@/components/xhtml/part001'
 import XHTMLCHAPTER001 from '@/components/xhtml/chapter001'
 import XHTMLCHAPTER002 from '@/components/xhtml/chapter002'
 import XHTMLCHAPTER003 from '@/components/xhtml/chapter003'
 import XHTMLPART002 from '@/components/xhtml/part002'
 import XHTMLCHAPTER004 from '@/components/xhtml/chapter004'
 import XHTMLCHAPTER005 from '@/components/xhtml/chapter005'
 import XHTMLCHAPTER006 from '@/components/xhtml/chapter006'
 import XHTMLCHAPTER007 from '@/components/xhtml/chapter007'
 import XHTMLCHAPTER008 from '@/components/xhtml/chapter008'
 import XHTMLCHAPTER009 from '@/components/xhtml/chapter009'
 import XHTMLCHAPTER010 from '@/components/xhtml/chapter010'
 import XHTMLCHAPTER011 from '@/components/xhtml/chapter011'
 import XHTMLCHAPTER012 from '@/components/xhtml/chapter012'
 import XHTMLCHAPTER013 from '@/components/xhtml/chapter013'
 import XHTMLINDEX001 from '@/components/xhtml/index001'
 import XHTMLINDEX002 from '@/components/xhtml/index002'
 import XHTMLINDEX003 from '@/components/xhtml/index003'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/acknowledgements",
 			"name" : "xhtml/acknowledgements",
 			"component" : XHTMLACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/introduction",
 			"name" : "xhtml/introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/part001",
 			"name" : "xhtml/part001",
 			"component" : XHTMLPART001
 		},
 		{
 			"path" : "/xhtml/chapter001",
 			"name" : "xhtml/chapter001",
 			"component" : XHTMLCHAPTER001
 		},
 		{
 			"path" : "/xhtml/chapter002",
 			"name" : "xhtml/chapter002",
 			"component" : XHTMLCHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js